import { render, staticRenderFns } from "./SingleSubstance.vue?vue&type=template&id=469273c4&scoped=true&"
import script from "./SingleSubstance.vue?vue&type=script&lang=js&"
export * from "./SingleSubstance.vue?vue&type=script&lang=js&"
import style0 from "./SingleSubstance.vue?vue&type=style&index=0&id=469273c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469273c4",
  null
  
)

export default component.exports